__turbopack_context__.v({
  "iconOnlyTrigger": "vcCFQa_iconOnlyTrigger",
  "menu": "vcCFQa_menu",
  "menuAlignLeft": "vcCFQa_menuAlignLeft",
  "menuAlignRight": "vcCFQa_menuAlignRight",
  "menuDirectionDown": "vcCFQa_menuDirectionDown",
  "menuDirectionUp": "vcCFQa_menuDirectionUp",
  "menuItem": "vcCFQa_menuItem",
  "menuItemLabel": "vcCFQa_menuItemLabel",
  "menuItemMeta": "vcCFQa_menuItemMeta",
  "triggerLabel": "vcCFQa_triggerLabel",
  "wrapper": "vcCFQa_wrapper",
});
